import { IconButton, Tooltip } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import EditIcon from '@material-ui/icons/Edit';
import { TechWriteScreenContext } from '../TechWriteProvider';
import ReceiptIcon from '@material-ui/icons/Receipt';
import React, { useContext } from 'react';
import AppContext from '../../../../App/AppContext';
import { AppStorage } from '../../../../Core/Service/storage-service';

export const ComplaintButtons = ({ value, copyToClipboard, index, name }) => {
    const { handleSuggestedTextModal } = React.useContext(TechWriteScreenContext);
    const { portalSettings } = useContext(AppContext);
    const canAccessTextReWriter = AppStorage.getCanAccessTextReWriter();

    return (
        <>
            {value && (
                <>
                    <Tooltip title="Copy text to clipboard" arrow>
                        <IconButton
                            style={{
                                padding: '1px',
                                marginLeft: '5px'
                            }}
                            onClick={() => copyToClipboard(value)}
                        >
                            <FileCopyIcon fontSize="small" color="secondary" />
                        </IconButton>
                    </Tooltip>
                    {portalSettings.portalSettingEnableTextRewriter && canAccessTextReWriter && (
                        <Tooltip title="Get suggested text" arrow>
                            <IconButton
                                style={{
                                    padding: '1px',
                                    marginLeft: '5px'
                                }}
                                onClick={() => handleSuggestedTextModal(value, index, name)}
                            >
                                <ReceiptIcon fontSize="small" color="secondary" />
                            </IconButton>
                        </Tooltip>
                    )}
                </>
            )}
        </>
    );
};
